import { render, staticRenderFns } from "./avatar-dropdown.vue?vue&type=template&id=3e7d146c&scoped=true"
import script from "./avatar-dropdown.vue?vue&type=script&lang=js"
export * from "./avatar-dropdown.vue?vue&type=script&lang=js"
import style0 from "./avatar-dropdown.vue?vue&type=style&index=0&id=3e7d146c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7d146c",
  null
  
)

export default component.exports